import { createContext, useContext } from 'react';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
// include default values to avoid null type checking in consumers
export const SubjectContext = /*#__PURE__*/createContext({
  objectType: CONTACT,
  subjectId: ''
});
export const useSubjectContext = () => {
  const {
    objectType,
    subjectId
  } = useContext(SubjectContext);
  return {
    objectType,
    subjectId
  };
};